__turbopack_context__.v({
  "floatingWrapper": "FloatingWhatsApp-module__QndPVW__floatingWrapper",
  "pulsePing": "FloatingWhatsApp-module__QndPVW__pulsePing",
  "tooltip": "FloatingWhatsApp-module__QndPVW__tooltip",
  "whatsappBtn": "FloatingWhatsApp-module__QndPVW__whatsappBtn",
});
